// extracted by mini-css-extract-plugin
export default {"dropdown":"BannerImageDropdown_dropdown__CXK0b","element":"BannerImageDropdown_element__sT1it","icon":"BannerImageDropdown_icon__kIj2M"};